/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it


import 'flowbite/dist/flowbite.min.js';
import '../maska-saas-interface/src/components/utils/apm';

// You can also add route change tracking here
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    const apm = require('./src/components/utils/apm').default
    const transaction = apm.startTransaction(`Navigate to ${location.pathname}`, 'route-change')
    transaction.end()
  }
}